import React from "react";
import PropTypes from "prop-types";

const Switch = ({ currentSwitchState, handleChange, id, disabled }) => (
  // eslint-disable-next-line jsx-a11y/control-has-associated-label
  <button
      className="switch__container"
      id={id}
      onClick={handleChange}
      type="button"
      disabled={disabled}
      data-testid="vt-switch"
    >
      <span
        className={`switch__slider${currentSwitchState ? " active" : ""}${
          disabled ? " disabled" : ""
        }`}
      >
        &nbsp;
      </span>
    </button>
);

export default Switch;

Switch.propTypes = {
  currentSwitchState: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};
